import React, {createContext} from 'react';

export const PageContext = createContext();